/* ============================================================
   CARINA — accordion.js
   Zugängliches Akkordeon-Web-Component
   ============================================================ */

'use strict';

class AccordionComponent extends HTMLElement {
  connectedCallback() {
    this.buttons = this.querySelectorAll('[data-accordion-button]');
    this.buttons.forEach((btn) => {
      btn.addEventListener('click', () => this._toggle(btn));
      // Initial state
      const panel = this._getPanel(btn);
      if (panel) {
        const expanded = btn.getAttribute('aria-expanded') === 'true';
        panel.setAttribute('aria-hidden', String(!expanded));
        if (!expanded) panel.classList.remove('is-open');
        else panel.classList.add('is-open');
      }
    });
  }

  _toggle(btn) {
    const expanded = btn.getAttribute('aria-expanded') === 'true';
    const panel = this._getPanel(btn);
    if (!panel) return;

    // Single-open mode: close others if [data-accordion-single]
    if (this.hasAttribute('data-accordion-single')) {
      this.buttons.forEach((other) => {
        if (other !== btn && other.getAttribute('aria-expanded') === 'true') {
          this._close(other, this._getPanel(other));
        }
      });
    }

    if (expanded) {
      this._close(btn, panel);
    } else {
      this._open(btn, panel);
    }
  }

  _open(btn, panel) {
    btn.setAttribute('aria-expanded', 'true');
    panel.setAttribute('aria-hidden', 'false');
    panel.classList.add('is-open');
  }

  _close(btn, panel) {
    btn.setAttribute('aria-expanded', 'false');
    panel.setAttribute('aria-hidden', 'true');
    panel.classList.remove('is-open');
  }

  _getPanel(btn) {
    const controls = btn.getAttribute('aria-controls');
    return controls ? document.getElementById(controls) : btn.nextElementSibling;
  }
}

window.AccordionComponent = AccordionComponent;
if (!customElements.get('accordion-component')) {
  customElements.define('accordion-component', AccordionComponent);
}

// Also support plain data-accordion containers (non-custom-element)
document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-accordion]:not(accordion-component)').forEach((wrapper) => {
    wrapper.querySelectorAll('[data-accordion-button]').forEach((btn) => {
      btn.addEventListener('click', () => {
        const expanded = btn.getAttribute('aria-expanded') === 'true';
        const panel = btn.nextElementSibling;
        btn.setAttribute('aria-expanded', String(!expanded));
        if (panel) {
          panel.setAttribute('aria-hidden', String(expanded));
          panel.classList.toggle('is-open', !expanded);
        }
      });
    });
  });
});
